<template>
  <div style="height: 713px" class="loading" v-if="mission_data === undefined && !mission_error">
    <Loading />
  </div>
  <section ref="factsSection" class="fun-facts-area ptb-30" v-else-if="mission_data" data-aos="fade-up" data-aos-delay="0" data-aos-duration="1000">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div class="col-lg-4 col-md-6 col-sm-6" v-for="i in [1,3,4]" :key="i">
          <div class="row justify-content-center">
            <div class="col-12 single-fun-fact text-center">
              <div class="icon" :class="{'loading-img': typeof mission_data.data[0][`counter${i}_icon`] === 'number'}">
                <img v-if="typeof mission_data.data[0][`counter${i}_icon`] !== 'number'" :src="mission_data.data[0][`counter${i}_icon`]" alt="">
                <img src="../assets/img/logo-circle.png" alt="" v-if="mission_data.data[0][`counter${i}_icon`] === 'default'">
              </div>
              <h3 class="counter-heading">
                      <span class="counter-animated">
                        <NumberAnimation :num="significantCounter(i)" :showNumbers="showNumbers" />
                      </span>
                      <span v-if="counterUnit(i)" class="counter-unit">{{ counterUnit(i) }}</span>
                      <span class="counter-plus">+</span>
              </h3>
              <p class="counter-description">{{ mission_data.data[0][`counter${i}_text`] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import Loading from "./Loading";
  import DefaultImage from "./DefaultImage";
  import NumberAnimation from "./NumberAnimation";

  export default {
    name: "EoyFactsArea",
    props: ['show'],
    components: {
      NumberAnimation,
      DefaultImage,
      Loading
    },
    data() {
      return {
        mission_data: {
          data: [
            {
              heading: "Our 30 Years of Impact",
              description: "From classrooms in Colorado to conferences in South Africa to community service projects worldwide, PeaceJam has nurtured a global movement of youth leaders who are tackling the most urgent challenges of our time.",
              counter1: 1500000,
              counter1_text: "Youth have participated in PeaceJam's education and service programs",
              counter1_icon: require('../assets/img/stat-icon-1.png'),
              // counter2: 30000000000,
              // counter2_text: "Acts Fellows supported through yearlong mentorship and funding",
              // counter2_icon: require('../assets/img/stat-icon-2.png'),
              counter3: 125000000,
              counter3_text: "Acts of Peace recorded across 171 countries",
              counter3_icon: require('../assets/img/stat-icon-3.png'),
              counter4: 350,
              counter4_text: "Youth Conferences Hosted across 45 countries",
              counter4_icon: require('../assets/img/stat-icon-4.png'),
            }
          ]
        },
        mission_error: false,
        mission_isValidating: false,
        showNumbers: false,
      };
    },
    mounted() {
      // Animate numbers when section is visible
      const observer = new window.IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.showNumbers = true;
            observer.disconnect();
          }
        });
      }, { threshold: 0.3 });
      if (this.$refs.factsSection) {
        observer.observe(this.$refs.factsSection);
      }
    },
    methods: {
      theFormat(value) {
        return Math.floor(value);
      },
      completed() {
        console.log('Animation ends!');
        this.show = true;
      },
      kFormatter(value) {
        if (value >= 1000000000) {
          return (value / 1000000000).toFixed(1).replace(/\.0$/, '') + ' Billion';
        } else if (value >= 1000000) {
          return (value / 1000000).toFixed(1).replace(/\.0$/, '') + ' Million';
        } else if (value >= 1000) {
          return (value / 1000).toFixed(1).replace(/\.0$/, '') + ' Thousand';
        } else {
          return value;
        }
      },
      significantCounter(i) {
        const val = this.mission_data.data[0][`counter${i}`];
        if (val >= 1000000000) {
          return parseFloat((val / 1000000000).toFixed(1));
        } else if (val >= 1000000) {
          return parseFloat((val / 1000000).toFixed(1));
        } else if (val >= 1000) {
          return parseFloat((val / 1000).toFixed(1));
        } else {
          return val;
        }
      },
      counterUnit(i) {
        const val = this.mission_data.data[0][`counter${i}`];
        if (val >= 1000000000) {
          return ' Billion';
        } else if (val >= 1000000) {
          return ' Million';
        } else if (val >= 1000) {
          return ' Thousand';
        } else {
          return '';
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .ptb-30 {
    padding:30px 0 ;
  }

  .single-fun-fact {
    text-align: center;
    
    .icon {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 15px;
      
      img {
        max-width: 100%;
        height: auto;
      }
    }
  }

  .counter-heading {
    display: flex;
    font-size: 30px;
    align-items: center;
    justify-content: center;
  }

  .counter-plus {
    font-weight:200; 
    margin-left:10px;
  }

  .counter-unit {
    font-size: 24px;
    margin-left:15px;
  }

  .counter-description {
    text-align: center;
  }

  @media (max-width: 550px) {
      .m-p-30 {
        padding-bottom: 30px;
      }
    }

</style>
